import React, { FunctionComponent } from "react"

interface CollabIconProps {}

const CollabIcon: FunctionComponent<CollabIconProps> = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6L9.33333 14L10.516 10.516L14 9.33333L6 6Z"
        stroke="#2F373D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.11419 7.88534L2.70085 9.30001M4.79219 1.49268L5.31019 3.42401L4.79219 1.49268ZM3.42419 5.31001L1.49219 4.79201L3.42419 5.31001ZM9.30019 2.70001L7.88552 4.11468L9.30019 2.70001Z"
        stroke="#2F373D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CollabIcon
